import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { encryptData } from "../../helpers/RSAUtility";
import userContext from "../../context/users/UserContext";
import NewReportWidget from "./NewReportWidget";
import StudyReportState from "../../context/studyreport/StudyReportState";
import AgenticReportingState from "../../context/agentic-reporting/AgenticReportingState";

const ReportWidgetLogin = () => {
    const [searchParams] = useSearchParams();
    const { signin } = useContext(userContext);
    
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const studyId = searchParams.get('studyId');
    const firmId = searchParams.get('firmId');

    const doAuthAndLoad = async (userName, password) => {
      try {
        const authResponse = await signin(encryptData(userName), password);
  
        document.cookie = `token=${authResponse.data.data.token}; Secure;`;
        document.cookie = `refresh-token=${authResponse.data.data.refreshToken}; Secure;`;
        
        if (authResponse?.status !== 200) {
            setErrorMessage("Authentication failed.");
            return;
        }
        setIsAuthenticated(true);
      } catch (err) {
        console.error("Login Error:", err);
        setErrorMessage("An unexpected error occurred during login.");
      }
    };

    useEffect(() => {
        const userName = searchParams.get("userName");
        if (!userName) {
            setErrorMessage("Username is missing from the URL.");
            return;
        }

        const isElectron = searchParams.get("isElectron");
        if (isElectron) {
          window.parent.postMessage({ type: "get-credentials", userName }, "*");
        }
    
        const handleMessage = (event) => {
          if (event.data?.type === "credentials" && event.data.password) {
            doAuthAndLoad(userName, event.data.password);
          }
        };
    
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, []);

    if (errorMessage) {
        return <p style={{ color: 'red' }}>Error: {errorMessage}</p>;
    }
      
    if (isAuthenticated) {
        return (
            <StudyReportState>
                <AgenticReportingState>
                    <NewReportWidget studyId={studyId} firmId={firmId} />
                </AgenticReportingState>
            </StudyReportState>
        );
    }

    return <p>Resolving secure access... Please wait.</p>;
}

export default ReportWidgetLogin;